import ActionType from '../models/enums/action-type';
import { MegawidgetSComponent } from '../components/megawidget/megawidget-specialty/megawidget-s.component/megawidget-s.component';
import { MegawidgetMComponent } from '../components/megawidget/megawidget-specialty/megawidget-m.component/megawidget-m.component';
import { MegawidgetLComponent } from '../components/megawidget/megawidget-specialty/megawidget-l.component/megawidget-l.component';
import { MegawidgetXLComponent } from '../components/megawidget/megawidget-specialty/megawidget-xl.component/megawidget-xl.component';
import { AutomaticComponent } from '../components/megawidget/megawidget-specialty/automatic-component';

class StateActions {
    static actions = {
        setPresentedDateIndex: ActionType.setStopPresentedDateIndex,
        setWidgetSize: ActionType.setWidgetSize,
        setActionType: ActionType.setResult
    }
}

class WidgetSizeHelper {
    static defaultVendor = "medicover";
    static S = {
        displayName: "s",
        presentedDates: 3,
        stateActions: StateActions.actions,
        minWidth: 0,
        maxWidth: 800,
        routeWithVendor: "/S/:vendor",
        routeWithoutVendor: "/S",
        component: MegawidgetSComponent
    }
    static M = {
        displayName: "m",
        presentedDates: 5,
        stateActions: StateActions.actions,
        minWidth: 210,
        maxWidth: 520,
        routeWithVendor: "/M/vendor:vendor/doctorCode:doctorCode",
        routeWithoutVendor: "/M",
        component: MegawidgetMComponent
    }
    static M2 = {
        displayName: "m",
        presentedDates: 5,
        stateActions: StateActions.actions,
        minWidth: 210,
        maxWidth: 520,
        routeWithVendor: "/M/vendor:vendor/doctorCode:doctorCode/color:color",
        routeWithoutVendor: "/M",
        component: MegawidgetMComponent
    }
    static L = {
        displayName: "l",
        presentedDates: 7,
        stateActions: StateActions.actions,
        minWidth: 1280,
        maxWidth: 1920,
        routeWithVendor: "/L/:vendor",
        routeWithoutVendor: "/L",
        component: MegawidgetLComponent
    }
    static XL = {
        displayName: "xl",
        presentedDates: 7,
        stateActions: StateActions.actions,
        minWidth: 1920,
        maxWidth: 1000000,
        routeWithVendor: "/XL/:vendor",
        routeWithoutVendor: "/XL",
        component: MegawidgetXLComponent
    }
    static AUTOMATIC = {
        displayName: "automatic",
        presentedDates: 7,
        stateActions: StateActions.actions,
        routeWithVendor: "/AUTOMATIC/:vendor",
        routeWithoutVendor: "/AUTOMATIC",
        component: AutomaticComponent
    }
}

export default WidgetSizeHelper;